import { render } from "./OljThreadDisplay.vue?vue&type=template&id=d8f6a452&scoped=true"
import script from "./OljThreadDisplay.vue?vue&type=script&lang=js"
export * from "./OljThreadDisplay.vue?vue&type=script&lang=js"

import "./OljThreadDisplay.vue?vue&type=style&index=0&id=d8f6a452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f6a452"]])

export default __exports__